<template>
  <b-form @submit.prevent="save">
    <SettingsTitleBar sub="Approval" :saving="saving" />
    <b-form-radio-group stacked v-model="form.approvalMode">
      <b-form-radio :value="null">
        No approval
        <small>Orders will be sent to production automatically</small>
      </b-form-radio>
      <b-form-radio value="review">
        Centralize review
        <small>An admin will need to review all orders before sending to production.</small>
      </b-form-radio>
      <b-form-radio value="payment">
        Centralize review+payment
        <small>An admin will need to review+enter billing for all orders before sending to production.</small>
      </b-form-radio>
    </b-form-radio-group>

    <div v-if="form.approvalMode">
      <label class="label" for="ad">How will approver be selected?</label>
      <b-form-radio-group id="ad" stacked v-model="form.approverDesignation">
        <b-form-radio :value="null">
          All admins
          <small>Requests will be sent to all admins</small>
        </b-form-radio>
        <b-form-radio value="chooseOnCheckout">
          Orderer chooses
          <small>Orderers may choose from all the admins during checkout.</small>
        </b-form-radio>
      </b-form-radio-group>

      <!-- <label class="label" for="gt">Approval by groups</label>
      <Toggle id="gt" v-model="form.approvalByGroup" trueLabel="Enable groups" falseLabel="Disable groups">
        <span slot="trueDescription">Filter admins by groups</span>
        <span slot="falseDescription">No group filtering</span>
      </Toggle> -->
    </div>

  </b-form>
</template>
<style scoped lang="scss">
small {
  display: block;
  color: #999;
  margin-bottom: 1em;
}
label.label {
  display: block;
  font-size: 1.3em;
  font-weight: bold;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      saving: false,
      form: {}
    }
  },
  mounted() {
    this.form = {
      approvalMode: null,

      ...this.approvalSettings
    };
  },
  computed: {
    ...mapGetters(['approvalSettings']),
  },
  methods: {
    ...mapActions(['updateTeam']),
    async save() {
      this.saving = true;
      await this.updateTeam({approval_settings:this.form});
      this.saving = false;
      this.$router.push('/dashboard/settings');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/settings/EditApproval.vue